import { render, staticRenderFns } from "./Usehistory.vue?vue&type=template&id=7761476b&"
import script from "./Usehistory.vue?vue&type=script&lang=js&"
export * from "./Usehistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports